import type { TabsProps } from "antd";
import { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import AuthSignUpCreatorTabComponent from "../../../components/AuthSignUpCreatorTabComponent";
import AuthSignUpFanTabComponent from "../../../components/AuthSignUpFanTabComponent";
import AuthTabsCompnent from "../../../components/AuthTabsComponent";
import SpinnerComponent from "../../../components/SpinnerComponent/SpinnerComponent";
import { CREATOR } from "../../../helpers/constant";
import { IUser } from "../../../helpers/types";
import AuthGoogleUnavailableComponent from "../../../components/AuthGoogleUnavailableComponent";
import useSignUpPageInfos from "../../../hooks/global/useSignUpPageInfos";
import { authService } from "../../../services";

const stepMap: { [key: string]: number } = {
  first: 2,
  second: 3,
  third: 4,
  fourth: 5,
};

const SignUpPage = () => {
  const { t } = useTranslation();
  useSignUpPageInfos(t);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");
  const [authGoogleUnavailable, setAuthGoogleUnavailable] = useState<boolean>(false);
  const [curentStep, setCurrentStep] = useState<Number>(0);
  const [usersId, setUsersId] = useState<string | null>(null);
  const [userEmail, setUserEmail] = useState<string | null>(null);
  const [currentUser, setCurrentUser] = useState<IUser | null>(null);
  const [isInitialized, setIsInitialized] = useState<boolean>(false);
  const hasChecked = useRef(false);
  const id = searchParams.get("id");
  const email = searchParams.get("email");
  const tabValue: any = searchParams.get("currentTab");

  const googleUnavailable = () => {
    setAuthGoogleUnavailable(true);
  };

  const googleUnavailableCancel = () => {
    setAuthGoogleUnavailable(false);
  };

  useEffect(() => {
    if (hasChecked.current) return;
    hasChecked.current = true;

    if (authService.isAuthenticated()) {
      const decodedToken = authService.getDecodedToken();

      const step = authService.getCreatorRegistrationStep();

      if (step && stepMap[step]) {
        const mappedStep = stepMap[step];

        setCurrentStep(mappedStep);
        setUsersId(decodedToken.sourceId);
        setUserEmail(decodedToken.email || null);
      } else {
        setCurrentStep(1);
      }
      setIsInitialized(true);
    } else {
      if (id && email) {
        setUserEmail(email);
        setUsersId(id);
      }
      setCurrentStep(1);
      setIsInitialized(true);
    }
  }, []);

  const tabs: TabsProps["items"] = [
    {
      key: "creator",
      label: t("auth-tab-creator"),
      children: (
        <AuthSignUpCreatorTabComponent
          setCurrentStep={setCurrentStep}
          curentStep={curentStep}
          setUserEmail={setUserEmail}
          userEmail={userEmail}
          setUsersId={setUsersId}
          usersId={usersId}
          setCurrentUser={setCurrentUser}
          currentUser={currentUser}
          googleUnavailable={googleUnavailable}
        />
      ),
    },
    {
      key: "fan",
      label: t("auth-tab-fan"),
      children: <AuthSignUpFanTabComponent googleUnavailable={googleUnavailable} />,
    },
  ];

  return (
    <>
      {authGoogleUnavailable ? (
        <AuthGoogleUnavailableComponent cancel={googleUnavailableCancel} />
      ) : !isInitialized ? (
        <div className="gradient-background h-full-screen d-flex justify-content-center align-items-center">
          <SpinnerComponent />
        </div>
      ) : (
        <div className="gradient-background">
          <h1 className="seo-hidden">{t("signup-page-h1")}</h1>
          {curentStep === 0 || curentStep === 1 ? (
            <div className="h-full">
              <AuthTabsCompnent tabs={tabs} defaultActiveKey={tabValue === CREATOR || token ? "creator" : "fan"} />
            </div>
          ) : (
            <div className="h-full-screen">
              <AuthSignUpCreatorTabComponent
                setCurrentStep={setCurrentStep}
                curentStep={curentStep}
                setUserEmail={setUserEmail}
                userEmail={userEmail}
                setUsersId={setUsersId}
                usersId={usersId}
                setCurrentUser={setCurrentUser}
                currentUser={currentUser}
                googleUnavailable={googleUnavailable}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default SignUpPage;
